import { handleGenericApiError } from "app/api/error";
import ReceivablesAnticipationRequests from "app/api/receivables-anticipation";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_RECEIVABLE_ANTICIPATION =
  "receivablesAnticipation:ACTION_SAVE_RECEIVABLE_ANTICIPATION";

export const importCsvReceivablesAnticipation =
  (data, callback) => async dispatch => {
    dispatch(addLoading());
    try {
      let response =
        await ReceivablesAnticipationRequests.importCsvReceivablesAnticipation(
          data
        );
      if (callback && typeof callback === "function") {
        callback();
      }
      return response;
    } catch (err) {
      handleGenericApiError(err);
    } finally {
      dispatch(removeLoading());
    }
  };

export const fetchReceivablesAnticipation = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data =
      await ReceivablesAnticipationRequests.fetchReceivablesAnticipation(
        params
      );
    dispatch({ type: ACTION_SAVE_RECEIVABLE_ANTICIPATION, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
